export const ns = "TextAreaScreen"

export default {
  [ns]: {
    writeHere: "Écrire ici…",
  },
}
